import React from "react"
import { withI18n } from "~/hocs"
import { assetURL } from "~/utils"
import { NextPage } from "next"
import { AppCommonProps } from "types/app"
import Link from "next/link"
import { routes } from "~/router"
import { Modal } from "react-bootstrap"
import config from "~/config"

const SecondDLModal: NextPage<AppCommonProps> = ({
  show,
  onHide,
  imageUrl,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modal-first-download"
    >
      <Modal.Body style={{ position: "relative" }}>
        <a href={`${config.premiumUrl}`}>
          <img className="modal-first-download-image" src={imageUrl} alt="Image" style={{ cursor: "pointer" }} />
        </a>
        <img
          src="/DAC_survey_x-mark.svg"
          alt="Close"
          width="40"
          style={{
            position: "absolute",
            top: "9%",
            left: "10%",
            cursor: "pointer",
          }}
          onClick={onHide}
        />
      </Modal.Body>
    </Modal>
  )
}
export default withI18n(SecondDLModal)
